module.exports = __webpack_public_path__ + "static/img/PersonCategoryManagement.891ec657.png";